import { watch } from 'vue';
import type { WatchSource } from 'vue';
import {
    // @ts-ignore
    $vfm,
} from 'vue-final-modal';
import MessageModal from '@/components/MessageModal.vue';
import type { FlashMessage, FlashMessages } from '../types';

export function useFlashMessages(messages: FlashMessages) {
    for (const [key, value] of Object.entries<FlashMessage>(messages)) {
        if (!value) {
            continue;
        }

        const title = typeof value === 'object' && value.hasOwnProperty('title')
            ? value.title
            : key.charAt(0).toUpperCase() + key.slice(1);

        const message = typeof value === 'object' && value.hasOwnProperty('body')
            ? value.body
            : value;

        $vfm.show({ component: MessageModal }, {
            title,
            message,
        });
    }
}

export function useWatchMessages(messages: WatchSource<FlashMessages | undefined>) {
    watch(messages, (value) => {
        if (value) {
            useFlashMessages(value);
        }
    });
}
